import type { Match } from '@/api/useSupplierReconciliation'
import type { MatchDetailResponse } from '@/api/useSupplierReconciliation/useMatchDetail'
import type { MatchDetailRow } from './MatchDetailPane'

export const isInvoiceVoided = (match: MatchDetailResponse, invoiceId: string) => {
  return (
    match?.void_invoices?.some(
      (voidedInvoice) => voidedInvoice._id === invoiceId || voidedInvoice.invoice_id === invoiceId
    ) || false
  )
}

export const getCanUnmatch = (match: Match | MatchDetailResponse, documents?: MatchDetailRow[]) => {
  const bols = Array.isArray(match?.bol_numbers) ? match.bol_numbers : []
  const invoices = Array.isArray(match.invoice_numbers) ? match.invoice_numbers : []
  const docs = Array.isArray(documents) ? documents : []
  return match.status !== 'approved' && [...docs, ...bols, ...invoices].filter((i) => i.id || i.document_id).length > 1
}

export const getDocumentsToUnmatch = (
  item: MatchDetailRow,
  allInvoiceDocuments: MatchDetailRow[],
  bolDocuments: MatchDetailRow[]
) => {
  const invoices = allInvoiceDocuments
    .filter((doc) => doc.document_id !== item.document_id)
    .map((doc) => ({
      invoice_id: doc.document_id,
      invoice_number: doc.document_number,
    }))
  const bols = bolDocuments
    .filter((doc) => doc.document_id !== item.document_id)
    .map((doc) => ({
      bol_id: doc.document_id,
      bol_number: doc.document_number,
    }))
  return { invoices, bols }
}
